import { Component, Inject, Input, ViewChild } from '@angular/core';
import { ApplicationStep, providers } from "../nuvei-application-step";
import { DOCUMENT } from "@angular/common";
import { timezones } from "../../../../../../common/src/lib/utils/timezones";
import { PlacesService } from '../../../../../../common/src/lib/services/places.service';
import { UtilsService } from "../../../../../../common/src/lib/services";
import { NuveiApplicationComponent } from "../nuvei-application.component";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import moment from "moment";
import { AddressFormFieldComponent } from "../../address-form-field/address-form-field.component";

@Component({
    selector: 'app-nuvei-application-dba',
    templateUrl: './nuvei-application-dba.component.html',
    styleUrls: ['./nuvei-application-dba.component.scss'],
    providers
})
export class NuveiApplicationDbaComponent extends ApplicationStep<'dbaForm'> {

    @ViewChild('addressInput') addressInput!: AddressFormFieldComponent;

    @Input() legalForm!: NuveiApplicationComponent['legalForm'];
    timezones = timezones;

    fieldExplanations = [
        {
            id: 'details',
            title: 'Business Name, Address, Phone Number & Business Creation Year and Month',
            explanation: 'The public-facing name, location, and contact details of your business. These may differ from your legal business information but can also be the same.'
        },
        {
            id: 'creationDate',
            title: 'Creation Date',
            explanation: 'When your business first started operating under this name publicly.'
        },
        {
            id: 'timezone',
            title: 'Time Zone',
            explanation: 'Your business\'s local time zone.You can find it by searching your city name followed by "timezone" online (e.g., New York timezone).\nIf your city spans multiple time zones, double-check the one that applies to your exact headquarters location.'
        },
    ];

    fieldToExplanations = {
        'businessName': 'details',
        'address': 'details',
        'unit': 'details',
        'phoneNumber': 'details',
        'creationDatePicker': 'creationDate',
    };

    showSameAsLegalButton$!: Observable<boolean>;

    constructor(
        @Inject(DOCUMENT) protected document: Document,
        protected placesService: PlacesService,
        protected utilsService: UtilsService,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.showSameAsLegalButton$ = this.form.valueChanges.pipe(
            startWith(this.form.value),
            map(dbaValue => {
                const legalValue = this.legalForm.value;

                if (dbaValue.creationDate === null)
                    return true;
                const dbaCreationData = moment(dbaValue.creationDate).format('MM/dd/YYYY');
                const legalCreationData = moment(legalValue.creationDate).format('MM/dd/YYYY');
                if (dbaCreationData !== legalCreationData) {
                    return true;
                }

                if (legalValue.businessPhoneNumber !== dbaValue.phoneNumber)
                    return true;

                const differentValue = (field: string, legalValue: any, dbaValue: any) => {
                    if(!dbaValue)
                        return true;
                    return legalValue[field] !== dbaValue[field];
                }
                return differentValue('businessName', legalValue, dbaValue)
                    || differentValue('unit', legalValue, dbaValue)
                    || differentValue('streetNumber', legalValue.address, dbaValue.address)
                    || differentValue('streetName', legalValue.address, dbaValue.address)
                    || differentValue('city', legalValue.address, dbaValue.address)
                    || differentValue('state', legalValue.address, dbaValue.address)
                    || differentValue('country', legalValue.address, dbaValue.address)
                    || differentValue('zip', legalValue.address, dbaValue.address);
            })
        );
    }

    copyFromLegalInformation() {
        const legalValue = this.legalForm.value;
        this.form.controls.businessName.setValue(legalValue.businessName!);
        this.addressInput.onPlacesOptionSelected(legalValue.address!)
        this.form.controls.unit.setValue(legalValue.unit!);
        this.form.controls.phoneNumber.setValue(legalValue.businessPhoneNumber!);
        this.form.controls.creationDate.setValue(legalValue.creationDate!);
    }

}